export const articles = [
  {
    title: "ADVANCED TELEMEDICINE",
    desc: "Telemedicine took a great leap forward during the Covid-19 pandemic. In January 2020, an estimated 24 percent of healthcare organizations had an existing telehealth program. According to Forrester, an analytics firm, the country was set to complete over a billion virtual care visits by the end of the year. Forced into functionality, many of telehealth’s regulatory barriers have been removed, and healthcare organizations now have nearly a year’s worth of data on how to evaluate and improve telehealth servicesFor 2021, many healthcare organizations will be focusing on how best to integrate telehealth services with existing physical ones. Virtual visits will continue to be used as a way to increase access to primary care and urgent care, as well as to improve collaboration with clinics, long-term care facilities, dialysis centers, and mental health services. All of this, however, hinges upon a more permanent lifting of regulatory barriers: the American Medical Association, and others, are urging Congress to act fast.",
  },
  {
    title: "NEW METHODS OF DRUG DEVELOPMENT",
    desc: `The development of multiple safe and effective Covid-19 vaccines in
    less than a year may be remembered as one of the greater scientific
    accomplishments in human history. The process was sped along not only
    by regulatory fast-tracking but also by innovations in the ways
    medical trials are conducted: virtual clinical trials, held mostly
    online, eased the burden of participation. Combined with a spirit of
    collaboration rather than competition between pharmaceutical
    companies, they could pave the way for a bright future in drug
    development.
    \n
    \n Some of the relaxed regulatory procedures around drug
    development will fade with the Covid-19 pandemic, but innovative
    approaches to testing and collaboration could linger. An alliance
    between several pharmaceutical heavyweights—including Gilead,
    Novartis, and WuXi AppTec—has already begun collaboratively exploring
    new antiviral treatments and sharing preliminary data. The FDA has
    released guidelines for virtual trials, opening up a new frontier for
    the development and testing of new drugs. Once Covid-19 is relegated
    to the history books, what’s next?`,
  },
];
